import {Vue, Component} from 'vue-property-decorator';
import { Observer } from "mobx-vue";

import Navigation from '@/components/Navigation';
import Swiper from '@/components/Swiper';
import Selection from '@/components/Selection';
import HeadlineButton from '@/components/Button/HeadlineButton';
import Log from '@/components/Log';

import PackageStore from '@/store/PackageStore';

import '@/style/package.less';

@Observer
@Component
export default class Package extends Vue {
  
  constructor(props: any) {
    super(props)
  }
  
  state = {
    PackageStore
  }
  
  async mounted () {
    console.log(this.$route.query.type === '1');
    if (this.$route.query.id) {
      this.state.PackageStore.setUserItemId(this.$route.query.id)
    }
  }
  
  render() {
    const {deviceType} = this.$route.query
    return (
      <div>
        <Navigation title='套餐购买' />
          <Swiper deviceType={deviceType ? Number(deviceType) : this.state.PackageStore.deviceType} priceType={this.state.PackageStore.priceType} events={{swiperOnChange:this.state.PackageStore.slidingSwiper}}/>
          <Selection changeSelection={this.state.PackageStore.onChangeSelection} activeData={this.state.PackageStore.activeData} data={{packageTopList: this.state.PackageStore.packageTopList, packageNormalList:this.state.PackageStore.packageNormalList }}/>
          <Log trackId={this.state.PackageStore.activeData.id} number={this.$route.query.type === '1' ? 'N0521' : 'N0511'}>
            <HeadlineButton click={this.state.PackageStore.routerPushConfirmOrder}>确认购买</HeadlineButton>
          </Log>
          <Log type='hooks' number={this.$route.query.type === '1' ? 'N0520' : 'N0510'}/>
      </div>
    )
  }
  
}